import { render } from "./Integrations.vue?vue&type=template&id=45a37036&scoped=true"
import script from "./Integrations.vue?vue&type=script&lang=js"
export * from "./Integrations.vue?vue&type=script&lang=js"

import "./Integrations.vue?vue&type=style&index=0&id=45a37036&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a37036"]])

export default __exports__